import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{
      borderTop: '1px solid #e5e7eb',
      padding: '20px',
      marginTop: '40px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#6b7280'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <p style={{ margin: '0 0 10px 0' }}>
          © {new Date().getFullYear()} Streamers Connected Media Ltd. All rights reserved.
        </p>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link
            to="/privacy"
            style={{ color: '#6b7280', textDecoration: 'none' }}
            onMouseEnter={(e) => e.target.style.color = '#111827'}
            onMouseLeave={(e) => e.target.style.color = '#6b7280'}
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            style={{ color: '#6b7280', textDecoration: 'none' }}
            onMouseEnter={(e) => e.target.style.color = '#111827'}
            onMouseLeave={(e) => e.target.style.color = '#6b7280'}
          >
            Terms of Service
          </Link>
        </div>
        <p style={{ margin: '14px auto 0', maxWidth: '900px', fontSize: '11px', lineHeight: 1.5, color: '#9ca3af' }}>
          Performance data is retrieved via the official platform APIs — the YouTube Data API, Twitch API, TikTok API,
          and Meta&rsquo;s Instagram Graph API — or, where an API does not provide a metric, manually verified from the
          public post. Game player counts, review totals and update announcements are retrieved via the Steam Web API
          and are provided as is, without warranty of accuracy. Metrics labelled as estimates (Impressions, Engagement
          Rate, Watch Hours) are calculated by Streamers Connected, are not provided by the platforms, and may differ
          from each platform&rsquo;s official analytics. YouTube, Twitch, TikTok, Instagram and Steam are trademarks of
          their respective owners; use of their data is subject to each platform&rsquo;s API terms. Streamers Connected
          is not affiliated with or endorsed by Valve Corporation.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
